// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { theme as defaultTheme } from "@insite/client-framework/Theme"; // Importing nothing to trigger
import { setPostStyleGuideTheme, setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import postStyleGuideTheme from "@keller/XDL/PostStyle";
import preStyleGuideTheme from "@keller/XDL/PreStyle";
import { canUseDOM } from "exenv";
import merge from "lodash/merge";

setPreStyleGuideTheme(preStyleGuideTheme);
setPostStyleGuideTheme(postStyleGuideTheme);

if (canUseDOM) {
    // to fix OOTB issue where styles doesn't apply on navigate
    (window as any).initialTheme = merge({}, postStyleGuideTheme, defaultTheme, preStyleGuideTheme);
}

// To fix an issue after upgrade v5.0.13 where shareEntity is not working
if (typeof window === "undefined") {
    const customTheme = merge({}, preStyleGuideTheme, postStyleGuideTheme) as any;
    defaultTheme.colors.common = customTheme.colors.common;
    defaultTheme.globalStyle = customTheme.globalStyle;
    defaultTheme.breadcrumbs = customTheme.breadcrumbs;
    defaultTheme.breakpoints = customTheme.breakpoints;
}
